import React, { FC, useMemo } from "react";
import { StyleProp, TouchableOpacity, ViewStyle } from "react-native";
import { Text } from "@lookiero/sty-psp-ui";
import { style as pillStyle } from "./Pill.style";

const ACTIVE_OPACITY = 0.6;

enum PillVariant {
  BASIC = "basic",
  PRIMARY = "primary",
}

interface PillProps {
  readonly active?: boolean;
  readonly onPress?: () => void;
  readonly variant?: PillVariant;
  readonly visible?: boolean;
  readonly style?: StyleProp<ViewStyle>;
  readonly children: string;
}

const Pill: FC<PillProps> = ({ active, onPress, variant = "basic", visible, style: customStyle, children }) => {
  const style = useMemo(() => pillStyle(), []);

  const variantStyle = useMemo(() => {
    switch (variant) {
      case PillVariant.BASIC:
        return {
          pill: [style.pillBasic, active && style.pillBasicActive],
        };
      case PillVariant.PRIMARY:
        return {
          pill: [style.pillPrimary, active && style.pillPrimaryActive],
        };
      default:
        return undefined;
    }
  }, [variant, style.pillBasic, style.pillBasicActive, style.pillPrimary, style.pillPrimaryActive, active]);

  return visible ? (
    <TouchableOpacity
      activeOpacity={ACTIVE_OPACITY}
      style={[style.pill, variantStyle?.pill, customStyle]}
      onPress={onPress}
    >
      <Text level={2} style={style.text} variant="detail">
        {children}
      </Text>
    </TouchableOpacity>
  ) : null;
};

export { PillVariant };
export { Pill };
